import styled from "styled-components";
import {Link} from "react-router-dom";

export const PanelMenuContainer = styled.div`
  flex-basis: 22%;
  padding-left: 1rem;
  padding-top: 1rem;
  border-left: 1px solid rgba(108, 140, 191, 0.30);
  margin-top: 2rem;
  
  & > div {
    position: sticky;
    top: 110px;
  }
`;

export const PanelContentContainer = styled.div`
  flex-basis: 78%;
  padding-right: 3rem;
  
  @media (max-width: 992px) {
    flex-basis: 100%;
    padding-right: 0;
  }

  @media (max-width: 1300px) and (min-width: 992px) {
    padding-right: 1rem;
  }
`;

export const ActiveRoute = styled(Link)`
  padding: 1rem;
  box-shadow: 1px 1px 5px 0 rgba(79, 104, 145, 0.05);
  -webkit-box-shadow: 1px 1px 5px 0 rgba(79, 104, 145, 0.05);
  -moz-box-shadow: 1px 1px 5px 0 rgba(79, 104, 145, 0.05);

  p {
     font-size: .95rem; 
  }
  
  i:not(.arrow)::before{
    color: var(--success-color);
    font-size: 1.2rem;
  }
  
  i.arrow {
    display: inline-block;
    transform: rotateZ(90deg);

    &::before {
      font-size: .4rem;
    }
  }
`;
